import { IActiveShipmentFragment } from '../graphql/ActiveShipmentFragment'
import { ITrackingType } from '../types'

interface IGetTrackingTypeProps
  extends Pick<IActiveShipmentFragment, 'etaObject' | 'trackingSummary'> {}

export const getTrackingType = ({
  etaObject,
  trackingSummary,
}: IGetTrackingTypeProps): ITrackingType => {
  const { onTime } = etaObject || {}
  const { isTracking } = trackingSummary || {}

  if (!isTracking) {
    return ITrackingType.notTracking
  }
  if (onTime) {
    return ITrackingType.onTime
  }
  return ITrackingType.runningLate
}
